import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  deleteCall,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { debounce } from "lodash";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";
import sortCaret from "../../components/SortCaret";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { FileTextIcon, LucidePlusCircle } from "lucide-react";
import { formatNumber, pastFinancialdate } from "../../lib/Misc";
import AddEditPayment from "./AddEditPayment";
import PaymentActionButton from "./PaymentActionButton";
import Confirmation from "../../components/Confirmation";
import CustomTooltip from "../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faEnvelope,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import { Button } from "../../components/ui/button";
import AdditionalDocumentEmailModal from "../../components/Email/AdditionalDocumentEmailModal";
import { toast } from "../../components/ui/use-toast";
// import axios from "axios";
// import PrintPreview from "../../components/PrintPreview";
// import MynaLogo from "../../assets/images/logo.png";
import { useTrust } from "../../lib/context/TrustContext";
import CommonFilters from "../../components/CommonFilters";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import ExpandPayment from "./ExpandPayment";
import PaymentAdviceTemplate from "../ABATransactions/PaymentAdviceTemplate";
import { CalendarDatePicker } from "../../components/CalendarDatePicker";
import { useMediaQuery } from "../../components/use-media-query";
import moment from "moment";
import axios from "axios";
import ReceiptItemsBasedOnSubAsset from "../Receipts/ReceiptItemsBasedOnSubAsset";
import { LawyerConditon } from "../../lib/PermissionConditions";
import { useOrganization } from "../../lib/context/OrganisationContext";

const Payments = ({ expandList = false, paymentData, expandedIds = [] }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [paymentList, setPaymentsList] = useState(
    expandList ? paymentData : [],
  );
  // const isDesktop = useMediaQuery("(min-width: 768px)");
  const isBigDesktop = useMediaQuery("(min-width: 1024px)");

  const { organizationData } = useOrganization();

  const [loading, setLoading] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const { trustId } = useTrust();

  const [paymentId, setPaymentId] = useState(null);
  const [showAddEditPayment, setShowAddEditPayment] = useState(false);
  const [showUndo, setShowUndo] = useState(false);
  const [showSendEmail, setShowSendEmail] = useState(false);
  const [files, setFiles] = useState([]);
  const [mailData, setMailData] = useState(false);
  const [showReceipts, setShowReceipts] = useState(false);

  const [ABAReceiptData, setABAReceiptData] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [showPaymentDelete, setShowPaymentDelete] = useState(false);

  const [vendorId, setVendorId] = useState();
  const [assetId, setAssetId] = useState();
  const [contactId, setContactId] = useState();
  const [contractId, setContractId] = useState();
  const [subAssetId, setSubAssetId] = useState();
  const [reversedId, setReversedId] = useState();
  const [refundId, setRefundId] = useState();

  useEffect(() => {
    if (state?.vendorId) {
      setVendorId(state?.vendorId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.vendorId]);

  const fromDate = query.get("from")
    ? new Date(query.get("from")?.split("-").reverse().join("-"))
    : "";
  const toDate = query.get("to")
    ? new Date(query.get("to")?.split("-").reverse().join("-"))
    : "";

  const [selectedDateRange, setSelectedDateRange] = useState(
    fromDate && toDate
      ? {
          from: fromDate,
          to: toDate,
        }
      : {
          from: pastFinancialdate[0],
          to: pastFinancialdate[1],
        },
  );

  const handleShowPreview = (paymentId) => {
    setShowPreview(!showPreview);
    paymentId ? fetchABAReceipt(paymentId, "preview") : setABAReceiptData();
  };

  const toggleShowDelete = () => {
    if (showPaymentDelete) {
      setPaymentId(null);
    }
    setShowPaymentDelete(!showPaymentDelete);
  };

  const fetchABAReceipt = async (paymentId, action) => {
    if (action === "preview") {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.PAYMENT_ABA_RECEIPT}/${paymentId}/${action}`,
        );
        setABAReceiptData(data?.data);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.PAYMENT_ABA_RECEIPT}/${paymentId}/${action}`,
        );
        setMailData(data?.data);
        handleSendEmail();
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const handleSendEmail = async (id) => {
    if (showSendEmail) {
      setFiles([]);
    } else {
      if (id) {
        await fetchABAReceipt(id, "email");
      }
    }
    setShowSendEmail(!showSendEmail);
    setPaymentId(id);
  };

  const PostDefaultMail = useCallback(async (id) => {
    if (id) {
      try {
        setLoading(true);
        await get(`${API.PAYMENT_ABA_RECEIPT}/${id}/email?send_email=1`);
        setShowSendEmail(false);
        fetchPayments(limit, page);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
    // eslint-disable-next-line
  }, []);

  const handleSubmit = async (values) => {
    if (paymentId) {
      try {
        setLoading(true);
        const formData = new FormData();
        // formData.append("id", paymentId);
        formData.append("type", "payment");
        formData.append("trust_id", trustId);

        for (const key in values) {
          if (key !== "ccChip" && key !== "bccChip") {
            if (key === "cc" || key === "bcc") {
              if (values[key]) {
                let valueData = values[key];
                for (
                  let valueIndex = 0;
                  valueIndex < valueData?.length;
                  valueIndex++
                ) {
                  formData.append(
                    `${key}[${valueIndex}]`,
                    valueData[valueIndex],
                  );
                }
              }
            } else {
              formData.append(key, values[key]);
            }
          }
        }
        files?.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });
        await fileUpload(`${API.SEND_EMAIL_DOCS}/${paymentId}`, formData);
        setShowSendEmail(false);
        fetchPayments(limit, page);
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    }
  };

  const toggleShowAddEditPayment = () => {
    if (showAddEditPayment) {
      setEdit(false);
      setEditItem(null);
      setPaymentId(null);
    }
    setShowAddEditPayment(!showAddEditPayment);
  };

  const toggleShowUndo = () => {
    if (showUndo) {
      setPaymentId(null);
    }
    setShowUndo(!showUndo);
  };

  const toggleShowReceipts = () => {
    if (showReceipts) {
      setPaymentId(null);
    }
    setShowReceipts(!showReceipts);
  };

  const handlePaymentUndo = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("module", "payment");
      formData.append("trust_id", trustId ? trustId : "");
      formData.append("ids[0]", paymentId);
      await fileUpload(`${API.JOURNAL_ENTRIES_UNDO}`, formData);
      setLoading(false);
      fetchPayments(limit, page);
      toggleShowUndo();
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchPayments = useCallback(
    async (passLimit, passPage) => {
      if (trustId) {
        try {
          setLoading(true);
          const { data } = await get(
            `${API.GET_PAYMENTS}?limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}&search=${
              searchParam ? searchParam : ""
            }&sort_column=${sortField ? sortField : ""}&sort_order=${
              sortOrder ? sortOrder : ""
            }&trust_id=${trustId ? trustId : ""}&vendor_id=${
              vendorId ? vendorId : ""
            }&contact_id=${contactId ? contactId : ""}&asset_id=${
              assetId ? assetId : ""
            }&sub_asset_id=${subAssetId ? subAssetId : ""}&contract_id=${
              contractId ? contractId : ""
            }&is_reversed=${reversedId ? reversedId : ""}&is_refund=${
              refundId ? refundId : ""
            }&start_date=${
              moment(selectedDateRange?.from).format("DD-MM-YYYY")
                ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
                : ""
            }&end_date=${
              moment(selectedDateRange?.to).format("DD-MM-YYYY")
                ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
                : ""
            }`,
          );

          setLoading(false);
          setLimit(data?.data?.per_page);
          setPage(data?.data?.current_page);
          setTotal(data?.data?.total);
          setFrom(data?.data?.from);
          setTo(data?.data?.to);
          const paymentList = data.data.data;
          setPaymentsList(paymentList);
          return data.data;
        } catch (error) {
          setLoading(false);
          setPaymentsList([]);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      trustId,
      searchParam,
      sortField,
      sortOrder,
      vendorId,
      contactId,
      assetId,
      subAssetId,
      reversedId,
      refundId,
      contractId,
      selectedDateRange?.from,
      selectedDateRange?.to,
    ],
  );

  // const downloadLetter = async (path) => {
  //   try {
  //     if (path) {
  //       // const response = await axios.get(`${path}`);
  //       // const fileData = response.data;
  //       const url = path;
  //       var a = document.createElement("a");
  //       a.href = url;
  //       a.target = "_blank";
  //       a.rel = "noopener noreferrer";
  //       var file = path.split("/");
  //       a.setAttribute("download", file[file.length - 1] || "new_aba.aba");
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //     } else {
  //       toast({
  //         variant: "destructive",
  //         description: "File does not exist.",
  //         duration: 3000,
  //       });
  //     }
  //   } catch (e) {}
  // };

  const downloadLetter = async (path) => {
    try {
      if (path) {
        const response = await axios.get(`${path}`, {
          responseType: "blob",
        });
        const fileData = response.data;
        const url = window.URL.createObjectURL(new Blob([fileData]));
        var a = document.createElement("a");
        a.href = url;
        var file = path.split("/");
        a.setAttribute("download", file[file.length - 1] || "new_aba.aba");
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        toast.error("File does not exist.");
      }
    } catch (e) {
      const errors = e.response?.data?.errors;
      Object.keys(errors).forEach((key) => {
        toast.error(errors[key][0]);
      });
    }
  };

  const paymentsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: paymentList[i]?.id,
        transaction_date: paymentList[i]?.transaction_date
          ? paymentList[i]?.transaction_date
          : "-",
        payment_number: paymentList[i]?.audit_no
          ? paymentList[i]?.audit_no
          : "-",
        total_amount: paymentList[i]?.total_amount ? (
          <b>{`$${formatNumber(Number(paymentList[i]?.total_amount))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        total_amount_exc: paymentList[i]?.total_amount_exc ? (
          <b>{`$${formatNumber(Number(paymentList[i]?.total_amount_exc))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        total_tax_amount:
          paymentList[i]?.payment_detail[0]?.tax === "1" &&
          paymentList[i]?.total_tax_amount ? (
            <CustomTooltip
              message={
                paymentList[i]?.payment_detail[0]?.tax === "1" &&
                ` (${paymentList[i]?.payment_detail[0]?.sub_asset?.tax_percentage}%)`
              }
            >
              <b>{`$${formatNumber(
                Number(paymentList[i]?.total_tax_amount),
              )}`}</b>
            </CustomTooltip>
          ) : (
            <b>{"$0.00"}</b>
          ),
        invoice_number: paymentList[i]?.invoice_number
          ? paymentList[i]?.invoice_number
          : "-",
        file_note: paymentList[i]?.file_note ? paymentList[i]?.file_note : "-",
        is_reversed: paymentList[i]?.is_reversed,
        is_refund: paymentList[i]?.is_refund,
        expandData: paymentList[i]?.payment_detail,
        receipt:
          paymentList[i]?.is_reversed === 1 ? (
            <></>
          ) : paymentList[i]?.deleted_at ? (
            <></>
          ) : paymentList[i]?.receipt_file ? (
            <span className="flex items-center gap-2 justify-center">
              <CustomTooltip message={"Preview"}>
                <span>
                  <FontAwesomeIcon
                    icon={faEye}
                    size="1x"
                    onClick={() => {
                      (paymentList[i]?.aba_file?.aba_file ||
                        !paymentList[i]?.is_reversed) &&
                        handleShowPreview(paymentList[i]?.id);
                    }}
                    className={`${
                      !paymentList[i]?.aba_file?.aba_file ||
                      paymentList[i]?.is_reversed
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
              <CustomTooltip message={"Download Remittance Advice"}>
                <span>
                  <FontAwesomeIcon
                    icon={faDownload}
                    size="1x"
                    onClick={() => {
                      (paymentList[i]?.receipt_file ||
                        !paymentList[i]?.is_reversed) &&
                        downloadLetter(paymentList[i]?.receipt_file);
                    }}
                    className={`${
                      !paymentList[i]?.receipt_file ||
                      paymentList[i]?.is_reversed
                        ? "opacity-50 cursor-not-allowed"
                        : ""
                    }`}
                  />
                </span>
              </CustomTooltip>
              <span>/</span>
              {paymentList[i]?.contact?.email !== null ? (
                <CustomTooltip message={"Email"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      onClick={() => {
                        !paymentList[i]?.is_reversed &&
                          handleSendEmail(paymentList[i]?.id);
                      }}
                      className={`${
                        paymentList[i]?.is_reversed
                          ? "opacity-50 cursor-not-allowed "
                          : ""
                      }`}
                    />
                  </span>
                </CustomTooltip>
              ) : (
                <CustomTooltip message={"Email address missing"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      size="1x"
                      disabled
                      className={"opacity-50 cursor-not-allowed"}
                    />
                  </span>
                </CustomTooltip>
              )}
              <span>/</span>
              <CustomTooltip message={"View Receipts"}>
                <span>
                  <FileTextIcon
                    size={16}
                    onClick={() => {
                      setPaymentId(paymentList[i]?.id);
                      toggleShowReceipts();
                    }}
                  />
                </span>
              </CustomTooltip>
            </span>
          ) : (
            <>
              <span className="flex items-center gap-2 justify-center">
                {" "}
                <CustomTooltip message={"View Receipts"}>
                  <span>
                    <FileTextIcon
                      size={16}
                      onClick={() => {
                        setPaymentId(paymentList[i]?.id);
                        toggleShowReceipts();
                      }}
                    />
                  </span>
                </CustomTooltip>
              </span>
            </>
          ),
        deleted_at: paymentList[i]?.deleted_at
          ? paymentList[i]?.deleted_at
          : "",
        action: (
          <>
            <PaymentActionButton
              id={paymentList[i]?.id}
              item={paymentList[i]}
              setPaymentId={setPaymentId}
              setEdit={setEdit}
              setEditItem={setEditItem}
              toggleShowAddEditPayment={toggleShowAddEditPayment}
              toggleShowUndo={toggleShowUndo}
              downloadLetter={downloadLetter}
              toggleShowDelete={toggleShowDelete}
            />
          </>
        ),
      });
    }
    return items;
  };

  const payments = paymentsGenerator(paymentList?.length);

  const columns = expandList
    ? [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "transaction_date",
          text: "Date",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "payment_number",
          text: "Payment Number",
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "invoice_number",
          text: "Invoice Number",
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "file_note",
          // text: "File Note",
          text: LawyerConditon(organizationData)
            ? "Matter Reference"
            : "File Note",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "total_amount",
          text: "Total Amount (Inc)",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "total_amount_exc",
          text: "Total Amount (Exc)",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "total_tax_amount",
          text: "Total Tax",
        },
      ]
    : [
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "transaction_date",
          text: "Date",
          sort: true,
          sortCaret,
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "payment_number",
          text: "Payment Number",
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "invoice_number",
          text: "Invoice Number",
          style: { width: "127px" },
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "file_note",
          // text: "File Note",
          text: LawyerConditon(organizationData)
            ? "Matter Reference"
            : "File Note",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "total_amount",
          text: "Total Amount (Inc)",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "total_amount_exc",
          text: "Total Amount (Exc)",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "total_tax_amount",
          text: "Total Tax",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "receipt",
          text: "Receipt",
          align: "center",
          headerAlign: "center",
        },
        {
          headerClasses: THClasses,
          classes: TDClasses,
          dataField: "action",
          text: "Action",
          align: "center",
          headerAlign: "center",
          style: { width: "127px" },
        },
      ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    if (!expandList) {
      navigate(
        `?limit=${limit ? limit : defaultLimitPagination}&page=${
          page ? page : 1
        }&search=${searchParam ? searchParam : ""}&sort_column=${
          sortField ? sortField : ""
        }&sort_order=${sortOrder ? sortOrder : ""}&from=${
          moment(selectedDateRange?.from).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.from).format("DD-MM-YYYY")
            : ""
        }&to=${
          moment(selectedDateRange?.to).format("DD-MM-YYYY")
            ? moment(selectedDateRange?.to).format("DD-MM-YYYY")
            : ""
        }`,
        {
          replace: true,
        },
      );
    }
  }, [
    navigate,
    limit,
    searchParam,
    page,
    sortField,
    sortOrder,
    expandList,
    selectedDateRange?.from,
    selectedDateRange?.to,
  ]);

  useEffect(() => {
    if (!expandList) {
      fetchPayments();
    }
  }, [expandList, fetchPayments]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchPayments(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchPayments(limit, page);
  };

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandPayment expandData={row?.expandData} />
      </>
    ),
    expanded: expandedIds,
    onlyOneExpanding: false,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  // Single Payment Delete
  const handlePaymentDelete = async () => {
    try {
      setLoading(true);
      await deleteCall(`${API.GET_PAYMENTS}/${paymentId}`);
      setLoading(false);
      fetchPayments(limit, page);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <MainBody
        search={!expandList}
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={
          !expandList && (
            <div className="flex items-center gap-3 flex-wrap">
              <CalendarDatePicker
                date={selectedDateRange}
                onDateSelect={setSelectedDateRange}
                variant="outline"
                align={isBigDesktop ? "end" : "start"}
                disabledDate={(date) => date > new Date()}
              />
              <CommonFilters
                trustId={trustId}
                contact={true}
                setContactId={setContactId}
                contactId={contactId}
                vendor={true}
                setVendorId={setVendorId}
                vendorId={vendorId}
                asset={true}
                setAssetId={setAssetId}
                assetId={assetId}
                subAsset={true}
                setSubAssetId={setSubAssetId}
                subAssetId={subAssetId}
                contract={true}
                setContractId={setContractId}
                contractId={contractId}
                reversed={true}
                reversedId={reversedId}
                setReversedId={setReversedId}
                refund={true}
                refundId={refundId}
                setRefundId={setRefundId}
              />

              {/* Add Payment */}
              <ResponsiveDrawerForm
                description={""}
                title={edit ? "Edit Payment(s)" : "Add Payment(s)"}
                handleOpen={() => {}}
                handleClose={() => {
                  setEdit(false);
                  setPaymentId();
                  setEditItem(null);
                }}
                buttonText={
                  <div className="flex items-center gap-1">
                    <LucidePlusCircle size={18} />
                    <span>Add Payment</span>
                  </div>
                }
                open={showAddEditPayment}
                buttonClassName={""}
                setOpen={setShowAddEditPayment}
                className={"md:max-w-[95vw] md:max-h-[95vh]"}
                mobileCancelHidden={true}
                write={true}
              >
                <AddEditPayment
                  edit={edit}
                  editItem={editItem}
                  toggleShowAddEditPayment={toggleShowAddEditPayment}
                  id={paymentId}
                  trustId={trustId}
                  fetchPaymentData={() => fetchPayments(limit, page)}
                />
              </ResponsiveDrawerForm>
            </div>
          )
        }
        loading={loading}
        expandList={expandList}
        mainClassName="w-[calc(100%-3rem)]"
      >
        <div className="custom-table">
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              remote
              data={payments}
              columns={columns}
              expandRow={expandRow}
              onTableChange={handleTableChange}
              rowClasses={(row) => {
                if (row?.is_reversed) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.is_refund) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                if (row?.deleted_at) {
                  return `${TRClasses} bg-muted dark:text-red-400 dark:bg-muted/50 text-red-600`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
          <Confirmation
            title={"Delete Payment"}
            open={showPaymentDelete}
            setOpen={setShowPaymentDelete}
            toggleShow={() => {
              toggleShowDelete();
            }}
            className="sm:max-w-1/2"
            message={"Are you sure you want to delete payment?"}
            okAction={async () => {
              handlePaymentDelete();
              toggleShowDelete();
              // fetchPayments();
            }}
            cancelAction={() => {
              setPaymentId(null);
              setShowPaymentDelete(!showPaymentDelete);
            }}
          />

          {showUndo && (
            <Confirmation
              title={"Undo Payment"}
              open={showUndo}
              setOpen={setShowUndo}
              toggleShow={() => {
                toggleShowUndo();
              }}
              className="sm:max-w-fit"
              message={
                <>
                  Are your sure you want to undo this payment?
                  <br />
                  This will reverse the beneficial interest journal entry and
                  payments journal entry if any.
                </>
              }
              okAction={async () => {
                await handlePaymentUndo();
              }}
              loading={loading}
              cancelAction={() => {
                toggleShowUndo();
              }}
            />
          )}

          <ResponsiveDrawerForm
            description={""}
            title={"Send Email"}
            handleOpen={() => {}}
            handleClose={() => {}}
            className={"sm:max-w-[50vw] max:min-w-screen"}
            open={showSendEmail}
            buttonClassName={""}
            setOpen={setShowSendEmail}
            read={true}
            mobileCancelHidden={true}
          >
            <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
              <AdditionalDocumentEmailModal
                defaultContent={
                  <>
                    <div className="text-center">
                      Are you sure you want to email this receipt to the
                      beneficiary for the payment?
                    </div>
                    <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
                      <Button
                        type="submit"
                        onClick={() => {
                          paymentId && PostDefaultMail(paymentId);
                        }}
                      >
                        Yes
                      </Button>
                      <Button
                        type="Button"
                        className="ml-3"
                        variant="secondary"
                        onClick={() => {
                          handleSendEmail();
                        }}
                      >
                        No
                      </Button>
                    </div>
                  </>
                }
                handleSubmit={handleSubmit}
                setFiles={setFiles}
                files={files}
                toggleCancel={handleSendEmail}
                // handleEditorChange={handleEditorChange}
                // editorState={editorState}
                mailData={mailData}
                type={"payment"}
                loading={loading}
              />
            </div>
          </ResponsiveDrawerForm>
          {showPreview && !loading && (
            <PaymentAdviceTemplate
              showView={showPreview}
              setShowView={setShowPreview}
              paymentData={ABAReceiptData}
            />
          )}
          <ResponsiveDrawerForm
            description={""}
            title={"Receipts"}
            handleOpen={() => {}}
            handleClose={() => {
              setShowReceipts(false);
              setPaymentId();
            }}
            buttonText={""}
            className={""}
            open={showReceipts}
            buttonClassName={""}
            setOpen={setShowReceipts}
            write={true}
          >
            <ReceiptItemsBasedOnSubAsset paymentId={paymentId} />
          </ResponsiveDrawerForm>
        </div>
      </MainBody>
    </>
  );
};

export default Payments;
